import { useCallback } from 'react';

import Button from '@mui/material/Button';

import { useRouter } from 'src/routes/hooks';

import { toast } from 'src/components/snackbar';

// ----------------------------------------------------------------------

export function CancelSubscriptionButton({ onClose, ...other }) {
    const router = useRouter();

    const handleCancelSubscription = useCallback(async () => {
        try {
            // TODO: Implementar lógica de cancelamento de assinatura
            // Aqui você pode chamar a API para cancelar a assinatura

            toast.success('Solicitação de cancelamento enviada!');
            onClose?.();

            // Opcional: redirecionar para página de confirmação
            // router.push('/subscription/cancel');
        } catch (error) {
            console.error(error);
            toast.error('Erro ao cancelar assinatura!');
        }
    }, [onClose]);

    return (
        <Button
            fullWidth
            variant="outlined"
            size="large"
            color="warning"
            onClick={handleCancelSubscription}
            sx={{ mb: 1.5 }}
            {...other}
        >
            Cancelar Assinatura
        </Button>
    );
}
